jQuery(document).ready(function ($) {
    if ($("form.cart").length) {
        let qty = $("form.cart").find(".qty");

        $("form.cart").on("click", "button.plus, button.minus", function () {
            // Get current quantity values
            let val = parseFloat(qty.val());
            let max = parseFloat(qty.attr("max"));
            let min = parseFloat(qty.attr("min"));
            let step = parseFloat(qty.attr("step"));

            // Change the value if plus or minus
            if ($(this).is(".plus")) {
                if (max && max <= val) {
                    qty.val(max);
                } else {
                    qty.val(val + step);
                }
            } else {
                if (min && min >= val) {
                    qty.val(min);
                } else if (val > 1) {
                    qty.val(val - step);
                }
            }
        });
    }
});
